import React from "react";
import {
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  SxProps,
  Typography,
} from "@mui/material";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import SecurityOutlinedIcon from "@mui/icons-material/SecurityOutlined";
import SupportAgentOutlinedIcon from "@mui/icons-material/SupportAgentOutlined";
import MarkEmailReadOutlinedIcon from "@mui/icons-material/MarkEmailReadOutlined";
import { useTranslations } from "hooks/useTranslations";

export const PaymentInfoList = () => {
  const {
    translations: {
      paymentMethod: { paymentInfoList },
    },
  } = useTranslations();

  const iconSx: SxProps = {
    fontSize: 16,
  };
  const iconMap = {
    lock: <LockOutlinedIcon sx={iconSx} />,
    security: <SecurityOutlinedIcon sx={iconSx} />,
    support: <SupportAgentOutlinedIcon sx={iconSx} />,
    emailConfirmation: <MarkEmailReadOutlinedIcon sx={iconSx} />,
  };

  return (
    <List sx={{ my: 2 }} dense>
      {paymentInfoList.map((paymentInfoListItem, index) => {
        const key = paymentInfoListItem.icon as keyof typeof iconMap;
        const mappedIcon = iconMap[key];
        return (
          <ListItem key={index} sx={{ pl: { md: 0 }, py: 0 }}>
            <ListItemIcon sx={{ minWidth: 24, color: "grey.700" }}>
              {mappedIcon}
            </ListItemIcon>
            <ListItemText>
              <Typography variant="bodySmall" sx={{ color: "grey.700" }}>
                {paymentInfoListItem.text}
              </Typography>
            </ListItemText>
          </ListItem>
        );
      })}
    </List>
  );
};
